import { TArrayTwoOrMore } from '@r1-frontend/shared/types/Array';

export default function isArrayOfTwoOrMore<T>(array?: T[] | null): array is TArrayTwoOrMore<T> {
    if (!array) {
        return false;
    }

    return array.length > 1;
}
